<!--
	We wrap everything in a <form> in every web page so we need a separate control
	for searchable input that handles Enter clicks
	because users tend to click Enter and send(submit) a form accidentally
-->
<template>
	<input
		v-model="internalValue"
		type="search"
		onkeydown="return event.key != 'Enter';"
		class="form-control"
	>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";

@Component({
	emits: ["update:modelValue"],
})
export class SearchInput extends Vue {
	@Prop({ required: true, type: String }) modelValue!: string;

	get internalValue(): string {
		return this.modelValue;
	}

	set internalValue(value: string) {
		this.$emit("update:modelValue", value);
	}
}

export default toNative(SearchInput);
</script>
